<template>
  <div :class="packageCardDesign">
    <div>
      <div
        :class="{
          border: true,
          'chosen-card': chosenPackage == packageCode,
          'rounded-1': true,
          'recommended-package': recommended && merchant_id === default_id,
        }"
      >
        <!-- <div
                :class="{
                'card-selected': chosenPackage == packageName,
                'card mx-auto': true,
                }"
            ></div> -->
        <div
          class="text-center py-1 recommended-flair"
          v-if="recommended && merchant_id === default_id"
        >
          KIEMELT
        </div>
        <div class="card-header" style="background-color: #E4002B">
          <h3 class="text-center text-white mt-2 package-header">
            {{ packageName }}
          </h3>
          <div v-if="merchant_id !== default_id" class="text-center text-white">
            {{ basePrice | currency }}
          </div>
          <div v-else class="text-center text-white">
            <div>akár már</div>
            <div class="text-decoration-line-through">
              {{ basePrice | currency }}-tól
            </div>
            <div class="fs-4 my-1 discount-package-price">
              {{ (basePrice * (1 - maxDiscount / 100)) | currency }}-tól
              <button
                type="button"
                class="info border border-white"
                id="kedvezmenyes_evesdij-tooltip"
                data-toggle="tooltip"
                data-placement="right"
                data-tooltip="kedvezmenyes_evesdij"
                title=""
              >
                ?
              </button>
            </div>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <button
              @click.prevent="updateChosenPackage"
              :class="{
                btn: true,
                'package-btn': chosenPackage !== packageCode,
                'chosen-package-btn': chosenPackage === packageCode,
              }"
            >
              {{ chosenPackage == packageCode ? "Kiválasztva" : "Kiválasztom" }}
            </button>
          </div>
        </div>
        <div class="card-body">
          <div>
            <div class="mt-2">
              <div class="row my-1">
                <div class="col-6">Főépület</div>
                <div v-if="rebuild_building === 0" class="col-6">
                  {{ packageDetails.alapfedezet.limit.foepulet | currency }}
                </div>
                <div v-else class="col-6">
                  Újraépítési / Újrabeszerzési érték
                </div>
              </div>
              <div class="row my-1">
                <div class="col-6">Melléképület</div>
                <div v-if="rebuild_building === 0" class="col-6">
                  {{ packageDetails.alapfedezet.limit.mellekepulet | currency }}
                </div>
                <div v-else class="col-6">
                  Újraépítési / Újrabeszerzési érték
                </div>
              </div>
              <div class="row my-1">
                <div class="col-6">Háztartási ingóságok</div>
                <div v-if="rebuild_ingosag === 0" class="col-6">
                  {{ packageDetails.alapfedezet.limit.ingosag | currency }}
                </div>
                <div v-else class="col-6">
                  Újraépítési / Újrabeszerzési érték
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6"><b>Biztosítási fedezet</b></div>
              <div class="col-6"><b>Biztosítási összeg</b></div>
            </div>
            <hr />
            <div>
              <div
                v-for="item of orderedAccessories"
                :key="packageDetails[item].kod"
                class="row my-3"
              >
                <div class="col-6">{{ packageDetails[item].nev }}</div>
                <div
                  v-if="packageDetails[item].kod == 'rbnb'"
                  class="col-6 text-center"
                >
                  Záradékok alapján
                </div>
                <div
                  v-else-if="typeof packageDetails[item].limit == 'object'"
                  class="col-6 text-center"
                >
                  Kötvény alapján
                </div>
                <div v-else class="col-6 text-center">
                  {{ packageDetails[item].limit | currency }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import _ from "lodash";

export default {
  props: {
    packageName: {
      type: String,
      required: true,
    },
    basePrice: {
      type: Number,
      required: true,
    },
    packageDetails: {
      type: Object,
      required: true,
    },
    packageCode: {
      type: String,
      required: true,
    },
    recommended: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    if (
      this.recommended &&
      this.merchant_id === this.default_id &&
      !this.fetch_uid
    )
      this.$store.commit("updateChosenPackage", this.packageCode);
  },
  computed: {
    ...mapFields([
      "chosenPackage",
      "generalInfo.rebuild_building",
      "generalInfo.rebuild_ingosag",
      "merchant_id",
      "maxDiscount",
      "fetch_uid",
      "generalInfo.rbnb",
      "default_id",
    ]),
    orderedAccessories: function() {
      // filtering due to additional data coming from nopa
      let filteredPackageDetails = Object.keys(this.packageDetails).filter(
        (i) => !_.isArray(this.packageDetails[i]),
      );
      return _.sortBy(
        filteredPackageDetails,
        (item) => this.packageDetails[item].sorrend,
      );
    },
    packageCardDesign: function() {
      if (this.merchant_id === this.default_id) {
        if (this.recommended) {
          return "col-md-6 col-lg-4 col-12 mt-3 mb-5 rounded-top-1 package-card";
        } else {
          return "col-md-6 col-lg-4 col-12 mt-5 mb-5 rounded-top-1 package-card";
        }
      }

      return "col-md-6 col-lg-4 col-12 mt-5 mb-5 rounded-top-1 package-card";
    },
  },
  methods: {
    updateChosenPackage() {
      // Call the mutations where it updates the chosenPackage
      if (this.$store.state.chosenPackage == this.packageCode) {
        this.$store.commit("updateChosenPackage", "");
      } else {
        this.$store.commit("updateChosenPackage", this.packageCode);
      }
      // console.log("currentPackage: " + this.$store.state.chosenPackage)
      this.$gtm.trackEvent({
        event: "package_selection", // Event type [default = 'interaction'] (Optional)
        category: "Calculator",
        action: "click",
        label: "package_selection",
        value: 5000,
        noninteraction: false, // Optional
      });
    },
  },
};
</script>
<style lang="css">
.package-btn {
  background-color: #007aa1 !important;
  border-color: #fefdfd !important;
  color: #fefdfd !important;
  text-shadow: 1px 1px 1px #666 !important;
  /* box-shadow: 1px 1px 3px 1px #F9CCD5 !important; */
}

.package-btn:hover {
  background-color: #fefdfd !important;
  color: #007aa1 !important;
  text-shadow: 1px 1px 1px #ccc !important;
}

.chosen-package-btn {
  background-color: #1c4256 !important;
  border-color: #fefdfd !important;
  color: #fefdfd !important;
  text-shadow: 1px 1px 1px #666;
}

.chosen-package-btn:hover {
  background-color: #fefdfd !important;
  color: #1c4256 !important;
  text-shadow: 1px 1px 1px #e6e6e6 !important;
}

.chosen-card {
  box-shadow: 0 0 18px #666666;
  background-color: #e6e6e6;
}
div > div > div.chosen-card {
  border: 1px solid #999999 !important;
  border-radius: 5px;
}
.recommended-flair {
  background-color: #006a52;
  font-weight: bold;
  letter-spacing: 1px;
  color: white;
  /* border: 2px solid #00AB8E; */
  text-shadow: 1px 1px 2px gray;
}
div > div > div.recommended-package {
  border: 2px solid #00ab8e !important;
  box-shadow: 0px 0px 15px 7px #332a2234 !important;
}

h3.package-header {
  text-shadow: 1px 1px 2px black !important;
}

.discount-package-price {
  text-shadow: 1px 1px 1px black;
}
</style>
